// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1etma","col":"styles_col__QIWdS"};